import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconControllerButtonX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconControllerButtonX"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M8 8L16 16M16 8L8 16" stroke="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonX;
